<template>
  <div class="infoAboutActionLog">
    <span class="title">{{ $t('fullHistory') }}</span>
    <div
      v-for="(actionsLog, index) in activeDelivery.actionsLog"
      :key="index"
      class="infoAboutActionLog-container"
    >
      <div v-if="actionsLog.assignedTime" class="info">
        <p>{{ $t('assignedTime') }}</p>
        <span> {{ dateTime(actionsLog.assignedTime) }} </span>
        <span v-if="actionsLog.assignedUserName">
          ( {{ actionsLog.assignedUserName }} )
        </span>
      </div>
      <div v-if="actionsLog.deleteTime" class="info">
        <p>{{ $t('deleted') }}</p>
        <span> {{ dateTime(actionsLog.deleteTime) }} </span>
        <span v-if="actionsLog.deleteUserName">
          ( {{ actionsLog.deleteUserName }} )
        </span>
      </div>
      <div v-if="actionsLog.lockerId" class="info">
        <p>{{ $t('lockerID') }}</p>
        <span> {{ actionsLog.lockerId.join(', ') }} </span>
      </div>
      <div v-if="actionsLog.reservedUserId" class="info">
        <p>{{ $t('reserved') }}</p>
        <span>
          {{
            actionsLog.reservedUserId === 'API'
              ? 'API'
              : actionsLog.reservedUserName
          }}
        </span>
      </div>
      <div
        v-for="updatesLog in actionsLog.updatesLog"
        :key="updatesLog.updateTime"
        class="infoUpdatesLog"
      >
        <div v-if="updatesLog" class="info">
          <p>{{ $t('deliveryHistoryPage.updated') }}</p>
          <span> {{ dateTime(updatesLog.updateTime) }} </span>
          <span v-if="updatesLog.updateUserName">
            ( {{ updatesLog.updateUserName }} )
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'InfoAboutActionLog',
  props: ['activeDelivery'],
  methods: {
    dateTime(value: number) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    }
  }
})
export default class InfoAboutDelivery extends Vue {}
</script>

<style lang="scss" scoped>
.infoAboutActionLog {
  margin-top: 24px;
  .title {
    font-family: 'Ubuntu-Medium';
    font-size: $eighteenSize;
    line-height: 15px;
  }
  .infoAboutActionLog-container {
    display: flex;
    flex-direction: column;
    height: 100px;
    padding: 16px;
    border: 1px solid $border;
    background-color: $light-grey;
    border-radius: 8px;
    margin-top: 23px;
    overflow-y: scroll;
    .info {
      margin-bottom: 25px;
      background-color: $light-grey;
      p {
        color: $label;
        line-height: 14px;
        font-size: $twelveSize;
        background-color: $light-grey;
      }
      span {
        color: $mid-grey;
        line-height: 14px;
        font-size: $fourteenSize;
        background-color: $light-grey;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .infoUpdatesLog {
      margin-bottom: 25px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
